import React from 'react';
import { x } from '@xstyled/styled-components';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { STATIC_CARD } from '../itemIds';

interface Props {
  text: string;
  width?: string;
  height?: string;
  padding?: string;
  borderRadius?: string;
  backgroundColor?: string;
}

export type StaticCardDefinition = ItemDefinition<typeof STATIC_CARD, Props>;

export class StaticCard extends Item<typeof STATIC_CARD, Props> {
  protected render({
    text,
    width = '280px',
    height = '200px',
    padding = '12px',
    borderRadius = '8px',
    backgroundColor = 'rgba(255, 255, 255, 0.5)'
  }: RenderProps<Props>) {
    return (
      <x.div
        w={width}
        h={height}
        p={padding}
        borderRadius={borderRadius}
        backgroundColor={backgroundColor}
        display="flex"
        alignItems="center"
        justifyContent="center"
        fontWeight="bold"
        fontSize="16px"
        color="#333"
        textAlign="center"
      >
        {text}
      </x.div>
    );
  }
}

registry[STATIC_CARD] = StaticCard;
